import type { ReactNode } from 'react';

export const symbol_file_export: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-480ZM329-207 222-100q-9 9-21 8.5t-21.39-9.5q-8.61-9-8.61-21t9-21l107-107h-96q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h168q12.75 0 21.38 8.62Q389-292.75 389-280v168q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q329-99.25 329-112v-95ZM168.5-378.63Q160-387.25 160-400v-420q0-24.75 17.63-42.38Q195.25-880 220-880h340l240 240v500q0 24.75-17.62 42.37Q764.75-80 740-80H479q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h261v-460H550q-12.75 0-21.37-8.63Q520-617.25 520-630v-190H220v420q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
